var React = require('react');

function GalleryPrevButtonMobile (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M14 1L2 21L14 41","stroke":"#F3F3F3","strokeWidth":"2","strokeLinecap":"round"}));
}

GalleryPrevButtonMobile.defaultProps = {"width":"15","height":"32","viewBox":"0 0 15 42","fill":"none"};

module.exports = GalleryPrevButtonMobile;

GalleryPrevButtonMobile.default = GalleryPrevButtonMobile;
